import request from "./request";

const PracticalExamService = {
    GetAll: async (id, context, signal) => {
        return await request.sendRequest(`/practicalexam/all/${id}`, context.token, signal);
    },
    Start: async (id, context) => {
        return await request.sendPutRequest(`/practicalexam/start/${id}`, context);
    },
    GetFile: async (id, context, signal) => {
        return await request.sendRequest(`/practicalexam/file/${id}`, context.token, signal);
    },
    Save: async (payload, context, signal) => {
        return await request.sendPostRequest(`/practicalexam`, payload, context, signal);
    },
    SaveDraft: async (payload, context, signal) => {
        return await request.sendFormDataRequest(`/practicalexam/draft`, payload, context, signal);
    },
    RemoveSession: async (assessmentId, userId, context) => {
        return await request.sendDeleteRequest(`/practicalexam/session/${assessmentId}/${userId}`, context.token);
    },
};

export default PracticalExamService;
